import { Calendar } from 'components/Calendar'
import styles from './DatePopper.module.css'
import { Popper } from '@mui/material'
import { ApplyButton } from '../ApplyButton'
import { CancelButton } from '../CancelButton'

interface DatePopperProps{
    open: boolean
    onClose?: (event: any) => void
    onCancel?: (event: any) => void
    onOk?: (event: any) => void
    anchorEl?: any
    popperOptions?: any
    loading?: boolean
    customDay?: any
}

export const DatePopper = (props: DatePopperProps): JSX.Element => {
    const {
        open,
        onCancel,
        onClose,
        onOk,
        anchorEl,
        popperOptions,
        loading = false,
        customDay = undefined
    } = props

    const handleSubmitForm = (event: any) => {
        event.preventDefault()
    }

    const handleApplyButtonClick = (event: any) => {
        onOk?.(event)
    }

    const handleCancelButtonClick = (event: any) => {
        onCancel?.(event)
    }

    return (
        <Popper
            className={styles.DatePopper}
            open={open}
            anchorEl={anchorEl.current}
            popperOptions={popperOptions}
        >
            <div className={styles.DatePopper__Content}>
                <form className={styles.Popper__Form} onSubmit={handleSubmitForm}>
                    <Calendar
                            loading={loading}
                            slots={{
                                calendarHeader: () => (null),
                                day: customDay,
                            }}
                    /> 
                    <div className={styles.Popper__EndContainer}>
                        <CancelButton 
                            onClick={handleCancelButtonClick}
                        />
                        <ApplyButton 
                            onClick={handleApplyButtonClick}
                        />
                    </div>
                </form>
            </div>
        </Popper>
    )
}